export const VIEW_ENTER = 'settledBets/VIEW_ENTER';
export const SET_BETS = 'settledBets/SET_BETS';
export const SET_VIEW_IS_LOADING = 'settledBets/SET_VIEW_IS_LOADING';
export const LOAD_PREVIOUS_WEEK = 'settledBets/LOAD_PREVIOUS_WEEK';
export const LOAD_NEXT_SLIP = 'settledBets/LOAD_NEXT_SLIP';

export const viewEnter = () => ({
  type: VIEW_ENTER
});

export const setBets = (results, incrementalByDate, incrementalBySlip, sinceDate) => ({
  type: SET_BETS,
  results,
  incrementalByDate,
  incrementalBySlip,
  sinceDate
});

export const setViewIsLoading = loading => ({
  type: SET_VIEW_IS_LOADING,
  loading
});

export const loadPreviousWeek = () => ({
  type: LOAD_PREVIOUS_WEEK
});

export const loadNextSlip = () => ({
  type: LOAD_NEXT_SLIP
});
